import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

const TIME_ENTRY_SUMMARY_QUERY = gql`
  query getTimeEntrySummary(
    $projectId: String!
    $filter: TimeEntryRevisionGroupFilter
  ) {
    project(projectId: $projectId) {
      id
      timeEntryRevisionGroupCount(filter: $filter)
      timeEntryRevisionGroupTotals(filter: $filter) {
        totalHours
      }
    }
  }
`;

export const useTimeEntrySummary = ({
  projectId,
  taskId,
  additionalFilters = {},
  skip = false
}) => {
  const { data, loading, error } = useQuery(TIME_ENTRY_SUMMARY_QUERY, {
    variables: {
      projectId,
      filter: {
        taskId: taskId === undefined ? null : taskId,
        ...additionalFilters
      }
    },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  const count = get(data, 'project.timeEntryRevisionGroupCount', 0);
  const totalHours = get(
    data,
    'project.timeEntryRevisionGroupTotals.totalHours',
    0
  );

  return {
    loading,
    count,
    totalHours,
    error
  };
};

export default useTimeEntrySummary;
